import { render, staticRenderFns } from "./error-logs-page.vue?vue&type=template&id=e28b672e&"
import script from "./error-logs-page.vue?vue&type=script&lang=js&"
export * from "./error-logs-page.vue?vue&type=script&lang=js&"
import style0 from "./error-logs-page.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports